import { render, staticRenderFns } from "./FontType.vue?vue&type=template&id=57c49499&scoped=true"
import script from "./FontType.vue?vue&type=script&lang=js"
export * from "./FontType.vue?vue&type=script&lang=js"
import style0 from "./FontType.vue?vue&type=style&index=0&id=57c49499&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c49499",
  null
  
)

export default component.exports